import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CancelContractComponent } from './cancel-contract/components/cancel-contract/cancel-contract.component';
import { CustomerSupportComponent } from './customer-support-activation/components/customer-support.component';
import { EditContractComponent } from './edit-contract/components/edit-contract.component';
import { ResendUcmComponent } from './resend-ucm/components/resend-ucm/resend-ucm.component';
import { UnitStatusComponent } from './unit-status/components/unit-status.component';
import { AuditTrailComponent } from './audit-trail/components/audit-trail/audit-trail.component';
import { TransferContractComponent } from './transfer-contract/components/transfer-contract/transfer-contract.component';
import { ReportsComponent } from './reports/components/reports.component';

const routes: Routes = [
    {
        path: 'unit-status',
        component: UnitStatusComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'unit-status/:id',
        component: UnitStatusComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'edit-contract',
        component: EditContractComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'resend-ucm',
        component: ResendUcmComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'customer-support-activation',
        component: CustomerSupportComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'audit-trail',
        component: AuditTrailComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'cancel-contract',
        component: CancelContractComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'transfer-contract',
        component: TransferContractComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [MsalGuard]
    }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class CommonRequestsRoutingModule {}
